import { EventPayloadType } from "@package/ui-gql/index-analytics";
import { type SliceWallScreenState } from "@package/ui-wall-engine";
import { useCallback } from "react";
import { Fragment } from "react/jsx-runtime";
import { useWallAnalytics } from "../../context/context-analytics/context-analytics";
import { useWallProvider } from "../../context/context-wall/context-wall";
import { LayoutPostContainer } from "../LayoutPostContainer/LayoutPostContainer";

export type ScreenLayoutCustomProps = {
  screen: SliceWallScreenState;
};

export function ScreenLayoutCustom({ screen }: ScreenLayoutCustomProps) {
  const provider = useWallProvider();
  const { trigger } = useWallAnalytics();

  const onHandleMouse = useCallback(
    (index: number, x: number, y: number) => {
      provider?.onPostInteracted(screen.id, screen.layoutPostPositions[index]);
      trigger(
        EventPayloadType.PostActioned,
        {
          flyout:
            screen.layoutPostPositions[index]?.post?.flyoutType ?? undefined,
          position: {
            x,
            y,
          },
          screen: screen.index,
        },
        screen.layoutPostPositions[index]?.post?.id ?? undefined,
        screen.layout?.id ?? undefined,
      );
    },
    [
      provider,
      screen.id,
      screen.index,
      screen.layout?.id,
      screen.layoutPostPositions,
      trigger,
    ],
  );

  if (!screen.layout.custom) {
    console.error(`Layout custom data not found (${screen.layout.id})`);
    return null;
  }

  return (
    <div
      className="relative"
      style={{
        width: screen.layout.custom.width,
        height: screen.layout.custom.height,
      }}
    >
      {screen.layout.custom.positions.map((position, index) => (
        <Fragment key={index}>
          {!!screen.layoutPostPositions[index] && (
            <div
              className="absolute"
              style={{
                width: position.width,
                height: position.height,
                left: position.x,
                top: position.y,
                padding: screen.layout.padding ?? 0,
              }}
              onPointerDown={(e) => onHandleMouse(index, e.screenX, e.screenY)}
            >
              <LayoutPostContainer
                layout={screen.layout}
                position={screen.layoutPostPositions[index]}
                screen={screen}
              />
            </div>
          )}
        </Fragment>
      ))}
    </div>
  );
}
